import { ColumnsType } from "antd/lib/table";
import { CrudTableWrapperProps } from "digimuth-components/dist/components/crudTable/crudTable";
import { CrudTable, nameof } from "digimuth-components/dist";
import { Direction, MenuCategoryDto, MenuEntryDto } from "../../api";
import { Button, Tag } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import styles from "./menuEntryListContainer.module.scss";

export default function MenuEntryList(props: MenuEntryProps) {
    const price = Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' });
    const minPoistion = props.data? Math.min(...props.data.map(e => e.position!)) : 0;
    const maxPosition = props.data? Math.max(...props.data!.map(e => e.position!)) : 0;

    const columns: ColumnsType<MenuEntryDto> = [
        {
            key: nameof<MenuEntryDto>("position"),
            dataIndex: nameof<MenuEntryDto>("position"),
            title: "Pozycja",
            render: (position, record) => <>
                <Button
                    style={position === minPoistion ? {visibility: "hidden"} : {visibility: "visible"}}
                    icon={<ArrowUpOutlined/>}
                    onClick={() => props.onPositionChangeClicked!(record.id!, Direction.Up)}
                />
                <Button
                    style={position === maxPosition ? {visibility: "hidden"} : {visibility: "visible"}}
                    icon={<ArrowDownOutlined/>}
                    onClick={() => props.onPositionChangeClicked!(record.id!, Direction.Down)}
                /></>
        },
        {
            key: nameof<MenuEntryDto>("name"),
            dataIndex: nameof<MenuEntryDto>("name"),
            title: "Nazwa"
        },
        {
            key: nameof<MenuEntryDto>("description"),
            dataIndex: nameof<MenuEntryDto>("description"),
            title: "Opis",
        },
        {
            key: nameof<MenuEntryDto>("prices"),
            dataIndex: nameof<MenuEntryDto>("prices"),
            title: "Cena",
            render: value => value.map((e: any) => price.format(e.value)).join(" / ")
        },
        {
            key: "attributes",
            title: "Atrybuty",
            render: (_, value, __) => <>
                {value.isVegan && <Tag>Wegańskie</Tag>}
                {value.isGlutenFree && <Tag>Bez glutenu</Tag>}
                {value.isGlutenFreeAvailable && <Tag>Zapytaj o gluten free</Tag>}
                {value.isDairyFree && <Tag>Bez laktozy</Tag>}
            </>
        }
    ];

    return <>
        <Button type="primary" onClick={props.onAddClicked} className={styles.newMenuEntryButton}>
            + Dodaj nowy wpis menu
        </Button>
        <CrudTable
            data={props.data}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            columns={columns}
            actionsFixed={false}
            editButtonTitle="Edytuj"
            deleteButtonTitle="Usuń"
            deleteConfirmMessage="Czy na pewno chcesz usunąć ten wpis?"
            cancelButtonTitle="Anuluj"
            pagination={{showSizeChanger:true}}
        />
    </>
}

interface MenuEntryProps extends CrudTableWrapperProps<MenuCategoryDto> {
    onPositionChangeClicked: (id: number, direction: Direction) => void
}
